import type { TurnProgress } from "../api/contract";
import { replyingLabel } from "../lib/buildProgress";

/** While Stax replies, the current stage's line; null when it isn't replying. */
export function useWorkingLabel(progress: TurnProgress | null | undefined, replying: boolean): string | null {
  return replying ? replyingLabel(progress) : null;
}
